import React from 'react'
import PropTypes from 'prop-types'
import ColumnLocationContext from '../contexts/ColumnLocationContext'

function TableFooter (props) {
  return (
    <ColumnLocationContext.Provider value='footer'>
      <tfoot className={props.className}>
        <tr>
          {props.children}
        </tr>
      </tfoot>
    </ColumnLocationContext.Provider>
  )
}

TableFooter.defaultProps = {
  className: ''
}

TableFooter.propTypes = {
  className: PropTypes.string
}

export default TableFooter
